import React, { useState } from "react";

import { useAuth } from "../../contexts/AuthContext";

import { toggleSidebarMobile } from "../../utils/sidebarUtils";

export const Navbar = () => {
  const { user, logout } = useAuth();
  const userName = user
    ? `${user?.first_name} ${user?.last_name}`
    : "john@doe.com";

  const [accountDropdownVisible, setAccountDropdownVisible] = useState(false);

  const handleLogout = () => {
    if (window.confirm("Are you sure you want to logout?")) {
      logout();
    }
  };

  const handleMouseEnter = () => {
    setAccountDropdownVisible(true);
  };

  const handleMouseLeave = () => {
    setAccountDropdownVisible(false);
  };

  return (
    <header className="account-header">
      <div className="mobile-sidebar-trigger" onClick={toggleSidebarMobile}>
        <i className="fas fa-bars"></i>
      </div>
      <div className="account-header-buttons">
        {/* <div className="circle-button">
          <i className="fas fa-bell"></i>
        </div>
        <div className="circle-button language">
          <i className="fas fa-globe"></i>
        </div> */}
        <div
          className="circle-button account"
          id="accountButton"
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <i className="fas fa-user"></i>
          {accountDropdownVisible && (
            <div className="account-dropdown">
              <div className="logged-user-details">
                <i className="fas fa-user"></i>
                <span>{userName}</span>
              </div>
              <ul>
                <li>
                  <a href="/account/dashboard">Dashboard</a>
                </li>
                {/* <li>
                  <a href="/account/edit-profile">Edit Profile</a>
                </li> */}
                <li className="logout" onClick={handleLogout}>
                  <span>Logout</span>
                </li>
              </ul>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};
